import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { Col, Divider, Row, Space, Spin } from 'antd'
import { isEmpty } from 'lodash'

import { UpdateDataText } from '../../../core/components/sections'

import {
  HistoryLink,
  NodeBreadcrumbs,
} from '../../../common/components/sections'
import { StyledPageSubTitle } from '../../../common/components/styled'
import { EVENT_METADATA_TYPES, METADATA_TYPES } from '../../../common/constants'
import { showErrorNotification } from '../../../common/helpers'
import { useDocumentTitle } from '../../../common/hooks'

import { renderCuisineTypeEvent } from '../../helpers'
import { useCuisineTypeQuery } from '../../hooks'
import {
  CuisineTypeImageDetailsForm,
  CuisineTypeSimpleDetailsForm,
} from '../forms'

const CuisineTypeDetailsPage = () => {
  const { id } = useParams()

  const {
    isLoading: isFetchLoading,
    error: fetchError,
    data,
  } = useCuisineTypeQuery(id)

  useDocumentTitle(`${data?.name || 'Loading Cuisine Type...'}`)

  useEffect(() => {
    if (fetchError) {
      showErrorNotification({
        title: 'Cuisine Type error',
        description: fetchError,
      })
    }
  }, [fetchError])

  return isFetchLoading || isEmpty(data) ? (
    <Spin />
  ) : (
    <>
      <StyledPageSubTitle>
        <Row justify="space-between">
          <Col span={12}>
            <NodeBreadcrumbs
              metadataType={METADATA_TYPES.CUISINE_TYPES}
              idPath={data.node.idPath}
              namePath={data.node.namePath}
            />
          </Col>

          <Space>
            <UpdateDataText
              updatedAt={data.updatedAt}
              updatedBy={data.updatedBy?.name}
            />

            <HistoryLink
              renderEvent={renderCuisineTypeEvent}
              entityId={id}
              eventMetadataTypes={[EVENT_METADATA_TYPES.CUISINE_TYPE]}
            />
          </Space>
        </Row>
      </StyledPageSubTitle>
      <CuisineTypeSimpleDetailsForm
        id={data.id}
        name={data.name}
        description={data.description}
        synonyms={data.synonyms}
        isErrorProne={data.isErrorProne}
        isExcludedFromSearch={data.isExcludedFromSearch}
        isExcludedFromBrowsing={data.isExcludedFromBrowsing}
        position={data.position}
        maxPosition={data.maxPosition}
      />
      <Divider />
      <CuisineTypeImageDetailsForm cuisineType={data} />
    </>
  )
}

export default CuisineTypeDetailsPage
